import { jsx } from "react/jsx-runtime";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ContactsFirstNameWUT = (props) => {
  const fieldType = FIELD_TYPES.CONTACTS_FIRST_NAME;
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType });
};
export {
  ContactsFirstNameWUT
};
//# sourceMappingURL=contacts-first-name-wut.js.map
